export const AreaVersionSituationModelConstants = {
  IN_ANALYSIS: {
    ID: '1',
    DESCRIPTION: 'Em Análise',
  },
  IN_PROGRESS: {
    ID: '2',
    DESCRIPTION: 'Em Andamento',
  },
  AWAITING_APPROVAL: {
    ID: '3',
    DESCRIPTION: 'Aguardando Aprovação',
  },
  APPROVED_COMPLETED: {
    ID: '4',
    DESCRIPTION: 'Aprovada/Concluída',
  },
  DECLINED: {
    ID: '5',
    DESCRIPTION: 'Reprovada',
  },
} as const
